import { render, staticRenderFns } from "./LandingContent.vue?vue&type=template&id=45b2898a&scoped=true&"
import script from "./LandingContent.vue?vue&type=script&lang=js&"
export * from "./LandingContent.vue?vue&type=script&lang=js&"
import style0 from "./LandingContent.vue?vue&type=style&index=0&id=45b2898a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b2898a",
  null
  
)

export default component.exports